var React = require('react');

function DownloadWithCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#2fa8ff"},[React.createElement("path",{"transform":"scale(.27907)","d":"m194.73 107.5c0-48.179-39.053-87.232-87.232-87.232s-87.232 39.053-87.232 87.232 39.053 87.232 87.232 87.232 87.232-39.053 87.232-87.232z","strokeWidth":"16","key":0}),React.createElement("path",{"transform":"scale(.27907)","d":"m82.263 119.8v3.1914c0 5.305 4.2972 9.6022 9.6022 9.6022h31.998c5.305 0 9.6022-4.2972 9.6022-9.6022v-3.1914m-12.808-12.808-12.794 12.808m0 0-12.808-12.808m12.808 12.808v-38.409","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4","key":1})]));
}

DownloadWithCircle.defaultProps = {"version":"1.1","viewBox":"0 0 60 60"};

module.exports = DownloadWithCircle;

DownloadWithCircle.default = DownloadWithCircle;
